const isProd = process.env.NODE_ENV === "production";
const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
const canTrack = Boolean(isProd && measurementId);

function injectGtag() {
  if (!canTrack || window.gtag) return;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", measurementId, { send_page_view: false });
}

export function initAnalytics() {
  injectGtag();
}

export function trackPageView(path) {
  if (!canTrack || !window.gtag) return;
  window.gtag("event", "page_view", { page_path: path });
}

export function trackEvent(name, params = {}) {
  if (!canTrack || !window.gtag) return;
  window.gtag("event", name, params);
}
